import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { noWhitespaceValidator } from '../../common';

@Component({
    selector: 'app-dialog-new-schedule',
    templateUrl: './dialog-new-schedule.component.html',
    styleUrls: ['./dialog-new-schedule.component.scss']
})
export class DialogNewScheduleComponent {
    formScheduleProps: FormGroup;
    showJump: boolean = false;
    editMode: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<any>, 
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any, 
    ) {
        this.formScheduleProps = this.fb.group({
            schedule_name: ['', [Validators.required, noWhitespaceValidator]],
            description: ['']
        });

        if (data) {
            this.showJump = !!data.showJump;
            this.editMode = !!data.editMode;

            if(this.editMode) {
                this.formScheduleProps.patchValue(data.data);
            }    
        }
    }

    get scheduleName() {
        return this.formScheduleProps.get('schedule_name');
    }

    onCreate() {
        if (this.formScheduleProps.get('schedule_name').value.trim().length == 0) return;
        this.dialogRef.close(this.formScheduleProps.value);
    }

    onClose() {
        this.dialogRef.close(null);
    }
}
